import React from 'react';
import SmartImage from '../../subcomponents/SmartImage';
import findAltText from '../../utils';

import './navengage.scss';

const NavEngage = ({
 element, url, isBootroom, loaded, version, campaignType, order,
}) => {
  const {
 bootNumber, 
 fileType, 
 imageNames, 
 urls, 
 noBackground, 
 backgroundColor, 
 useGradient,
 backgroundGradient, 
 gradientDirection, 
 cta, 
 willFloat, 
 brand, 
 hide,
 arrowDown, 
 arrowDownColor, 
 navEngageNumber, 
 type, 
 anchorName, 
 roundedCorners, 
 removeArrow,
} = element;
  const { slug, imagePattern } = url;
  const commonTranslations = window.campaign_data.common_translations.blocks;
  let number = 0;
  const style = {
    backgroundColor: cta.ctaBackgroundColor,
    color: cta.ctaTextColor,
    border: `2px solid ${cta.ctaBorderColor}`,
  };
  const roundTheCorners = (campaignType === 'general' && roundedCorners) ? 'rounded-corners' : '';
  let engageName = `010-engage${imagePattern}`;
  if (bootNumber === '3' && window.innerWidth < 768) {
    engageName = `010-engage-short${imagePattern}`;
  }
  if (campaignType === 'general') engageName = `010-nav-engage${navEngageNumber}${imagePattern}`;

  // If no background image, the engage will load immediately, otherwise pass loaded() to smartImage
  if (noBackground) loaded();
  let component = null;
    let styler = {};
     if (noBackground && useGradient && gradientDirection === 'leftToRight') {
       styler = { background: `linear-gradient(to right, ${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && useGradient && gradientDirection === 'topToBottom') {
       styler = { background: `linear-gradient(${backgroundColor} 0%, ${backgroundGradient} 100%)` };
    } else if (noBackground && !useGradient) {
       styler = { background: backgroundColor };
    } else {
       styler = {};
        }
  if (!hide) {
    component = (
      <section
        id={anchorName || ''}
        className={noBackground ? `component nav-engage-section smart-section smart-section-${bootNumber}` : 'component nav-engage-section'}
        style={styler}
        dataorder={order}
        datatype={type}
      >
        {!noBackground &&
          <SmartImage
            slug={slug}
            name={engageName}
            version={version}
            campaignType={campaignType}
            className={campaignType === 'general' ? 'heightBackground' : ''}
            alt={findAltText(`Navigation Engage Background ${navEngageNumber}`)}
          />
        }
        <div className="mainWidth">
          {bootNumber === '2' ?
            <div className="navigation two-boots">
              {imageNames.map((name, index) => {
                if (name !== '') {
                  let bootUrl = isBootroom ? `http://scalaadmin.dk/Unisport/bootroom/brand/${brand}/${urls[index]}.html` : `/v/${urls[index]}`;
                  if (!urls[index]) bootUrl = '#';
                  return (
                    <a
                      className={`nav-link nav-link${index + 1}`}
                      href={bootUrl}
                      key={name}
                      style={bootUrl === '#' ? { cursor: 'default' } : {}}
                    >
                      <div className={`boot-holder boot-holder${index + 1}`}>
                        <img className="boot" src={`${slug}elements/${name}${fileType}?version=${version}`} alt={findAltText(`Navigation Engage ${name} ${navEngageNumber}`, name)} />
                      </div>
                      <div className={`lockup-holder lockup-holder${index + 1}`}>
                        <img className={`lockup lockup${index + 1}`} src={`${slug}elements/${name}-lockup.png?version=${version}`} alt={findAltText(`Navigation Engage ${name} Lockup ${navEngageNumber}`, `${name} lockup`)} />
                        {urls[index] &&
                          <div className={`cta ${roundTheCorners} ${campaignType === 'general' && removeArrow ? 'noArrow' : ''}`} style={style}>
                            {commonTranslations.explore}
                            {(campaignType !== 'general' || !removeArrow) &&
                            <svg alt="arrow" xmlns="http://www.w3.org/2000/svg" width="9.41" height="14" stroke={cta.ctaArrowColor} fill="none" strokeWidth="2px" fillRule="evenodd" viewBox="0 0 9.41 14">
                              <path
                                className="cta-arrow"
                                data-name="elements/arrow-cta.svg"
                                d="M4106.25,694.01l5.99,5.989-5.99,5.99"
                                transform="translate(-4103.84 -693)"
                              />
                            </svg>
                            }
                          </div>
                        }
                      </div>
                    </a>
                  );
                } return null;
              })}
            </div>
          :
            <React.Fragment>
              <div className="image-holder">
                <picture>
                  <source media="(min-width: 768px)" srcSet={`${slug}elements/desktop/title.png?version=${version}`} />
                  <img src={`${slug}elements/mobile/title.png?version=${version}`} alt={findAltText(`Navigation Engage Title ${navEngageNumber}`)} />
                </picture>
              </div>
              <div className={`navigation nav-boot-${bootNumber}`}>
                {
                imageNames.map((name, index) => {
                  if (name !== '') {
                    number += 1;
                    let bootUrl = isBootroom ? `http://scalaadmin.dk/Unisport/bootroom/brand/${brand}/${urls[index]}.html` : `/v/${urls[index]}`;
                    if (!urls[index]) bootUrl = '#';
                    return (
                      <a
                        key={name}
                        className={`nav-link boot-count-${bootNumber}`}
                        href={bootUrl}
                        style={bootUrl === '#' ? { cursor: 'default' } : {}}
                      >
                        <div className={`boot-holder ${willFloat ? 'float' : ''}`}>
                          <picture>
                            <source media="(min-width: 768px)" srcSet={`${slug}elements/desktop/0${number}-${name}${fileType}?version=${version}`} />
                            <source srcSet={`${slug}elements/mobile/0${number}-${name}${fileType}?version=${version}`} />
                            <img src={`${slug}elements/mobile/0${number}-${name}${fileType}?version=${version}`} alt={findAltText(`Navigation Engage ${name} ${navEngageNumber}`, name)} className={`boot boot${index + 1}`} />
                          </picture>
                        </div>
                        <div className="lockup-holder">
                          <picture>
                            <source media="(min-width: 768px)" srcSet={`${slug}elements/desktop/0${number}-lockup-${name}${fileType}?version=${version}`} />
                            <img className="lockup" src={`${slug}elements/mobile/0${number}-lockup-${name}${fileType}?version=${version}`} alt={findAltText(`Navigation Engage ${name} Lockup ${navEngageNumber}`, `${name} lockup`)} />
                          </picture>
                          {urls[index] ?
                            <div className="cta" style={style}>
                              {commonTranslations.explore}
                              <svg alt="arrow" xmlns="http://www.w3.org/2000/svg" width="9.41" height="14" stroke={cta.ctaArrowColor} fill="none" strokeWidth="2px" fillRule="evenodd" viewBox="0 0 9.41 14">
                                <path
                                  className="cta-arrow"
                                  data-name="elements/arrow-cta.svg"
                                  d="M4106.25,694.01l5.99,5.989-5.99,5.99"
                                  transform="translate(-4103.84 -693)"
                                />
                              </svg>
                            </div>
                            :
                            <div className="cta-spacer" />
                          }
                        </div>
                      </a>
                    );
                  }
                  return null;
                })
              }
              </div>
            </React.Fragment>
          }
          { arrowDown &&
           <div className="arrowHolder">
            <svg alt="arrow down" xmlns="http://www.w3.org/2000/svg" width="19.94" height="10.875" viewBox="0 0 21.94 12.875">
              <path
                className="arrowDownSvg"
                stroke={arrowDownColor}
                fill="none"
                d="M4161.98,749.92l-9.98,9.436-9.98-9.436"
                transform="translate(-4141.03 -747.469)"
              />
            </svg>
           </div>
           }
        </div>
      </section>
    );
  }
  return (
    <React.Fragment>
      { component }
    </React.Fragment>
  );
};

export default NavEngage;
